import { useContext } from 'react';
import { AccessibilityContext } from '@monash/portal-frontend-common';
import { DataContext } from '../components/providers/data-provider/DataProvider';
import { useSnackbar } from '@/components/providers/SnackbarProvider';

const PREFERENCES_WRITE_BLOCKED_MESSAGE =
  "We can't save your preferences right now - please try again later";

const usePreferencesErrorWriteGuard = () => {
  const { errors } = useContext(DataContext);
  const { resetAppLiveMsgs } = useContext(AccessibilityContext);
  const { addSnackbar } = useSnackbar();

  /** @returns {boolean} true when the write must not proceed */
  const blockWriteIfPreferencesError = () => {
    if (!errors?.portalPreferences) {
      return false;
    }

    resetAppLiveMsgs();
    addSnackbar({
      message: PREFERENCES_WRITE_BLOCKED_MESSAGE,
      type: 'error',
    });
    return true;
  };

  return { blockWriteIfPreferencesError };
};

export default usePreferencesErrorWriteGuard;
